export class UnmanagedDocumentSummaryInformation {
  constructor(
    public documentId: number,
    public patientNo: string,
    public formatOriginalId: number,
    public isUnmanaged: boolean,
    public isQuotable: boolean,
    public alternativeFormatOriginalId: number,
  ) {}
}
